/**
 * TanStack Router: /my-onboarding
 *
 * This route file was auto-generated by the route generation script.
 * Component: MyOnboardingPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import MyOnboardingPage from '@/app/my-onboarding/page'

/**
 * Route: /my-onboarding
 * Layout: _auth (authenticated)
 * Component: MyOnboardingPage
 */
export const Route = createFileRoute('/_auth/my-onboarding')({
  component: MyOnboardingPage,
})
